"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const mailbrand04 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 51",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-mailbrand04` : '') + (description ? ` desc-mailbrand04` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-mailbrand04"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-mailbrand04"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.343 4.547H71.59V51H4.343V4.547Z",
    fill: "#F1C4DC",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#D01481"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 .985C0 .441.44 0 .98 0h67.247c.542 0 .981.441.981.985v46.453a.983.983 0 0 1-.98.985H.98A.983.983 0 0 1 0 47.438V.985Zm1.961.985v44.483h65.286V1.97H1.96Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.942 12.818a.978.978 0 0 1 1.363-.26l24.3 16.655 24.298-16.654a.978.978 0 0 1 1.363.259.988.988 0 0 1-.257 1.369L35.157 31.218a.977.977 0 0 1-1.106 0L9.2 14.186a.988.988 0 0 1-.257-1.368ZM20.825 29.897a.988.988 0 0 1-.334 1.352l-10.233 6.194a.978.978 0 0 1-1.346-.335.988.988 0 0 1 .334-1.352l10.233-6.194a.978.978 0 0 1 1.346.335ZM48.383 29.897a.978.978 0 0 1 1.346-.335l10.233 6.193c.464.281.613.887.334 1.353a.978.978 0 0 1-1.346.335L48.717 31.25a.988.988 0 0 1-.334-1.352Z"
  }))));
};
var _default = exports.default = mailbrand04;